import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let isAuth = this.authService.isAuthenticated();
    let userRoles = this.authService.getUserRoles();
    const rolesPermitidos = route.data.rolesPermitidos;
   
    if (!isAuth) {
      this.router.navigate(['/pages/login']);
      return false;
    }  else {
      return true;
    }
  }
}
